import FormComponent from "../../common/FormComponent";
import React from "react";
import { bindActionCreators } from "redux";
import * as Actions from "../../actions/Actions";
import { withRouter } from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import Grid from "@material-ui/core/Grid";
import { Paper } from "@material-ui/core";
import strings from "../../localization";
import { withSnackbar } from "notistack";
import CremationStatementForm from "../../components/forms/cremationStatement/CremationStatementForm";
import { getCremationStatementById } from "../../services/cremationStatement/CremationStatementService";
import { getGraveSiteById } from "../../services/graveSite/GraveSiteService";
import { getGraveyardById } from "../../services/graveyard/GraveyardService";

class ViewCremationStatement extends FormComponent {

  constructor(props) {
    super(props);

    this.state = {
      data: props.data ? props.data : {},
      errors: {}
    };

    this.props.changeFullScreen(false);
  }

  componentDidMount() {
    getCremationStatementById(this.props.id, this.props.auth.user.id, this.props.auth.user.company.id).then(response => {
      this.setState({
        data: response.data,
        settlements: [response.data.municipality],
        states: [response.data.state]
      }, () => {
        {
          this.state.data.graveyardId &&
            getGraveyardById(this.state.data.graveyardId, this.props.auth.user.id, this.props.auth.user.company.id).then(response => {
              this.setState({
                data: {
                  ...this.state.data,
                  graveyard: response.data
                },
                graveyards: [response.data]
              });
            });
        }
        {
          this.state.data.graveSiteId &&
            getGraveSiteById(this.state.data.graveSiteId, this.props.auth.user.id, this.props.auth.user.company.id).then(response => {
              this.setState({
                data: {
                  ...this.state.data,
                  graveSite: response.data
                },
                graveSites: [response.data],
              });
            })
        }
      });
    });
  }

  render() {

    return (
      <Grid id="page" item md={12}>
        <div className="header">
          <h1>{strings.cremationStatementList.pageTitle}</h1>
        </div>

        <Paper className="paper">
          <CremationStatementForm
            onChange={this.changeData}
            data={this.state.data}
            errors={this.state.errors}
            onCancel={this.props.onCancel}
            isDisabled={this.props.isDisabled}
            municipalities={this.state.settlements == undefined ? [] : this.state.settlements}
            states={this.state.states == undefined ? [] : this.state.states}
            graveyards={this.state.graveyards == undefined ? [] : this.state.graveyards}
            graveSites={this.state.graveSites == undefined ? [] : this.state.graveSites}
          />
        </Paper>

      </Grid>
    );
  }
}

function mapDispatchToProps(dispatch) {

  return bindActionCreators(
    {
      changeFullScreen: Actions.changeFullScreen
    },
    dispatch
  );
}

function mapStateToProps({ menuReducers, siteDataReducers }) {

  return { menu: menuReducers, siteData: siteDataReducers };
}

export default withSnackbar(
  withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ViewCremationStatement)
  )
);
